
const SELECTOR = {
    ACTIVE: '_active',
    FOCUSABLE: 'a,[tabindex]'
};

$('.js-c-user-type').each((i, rootDom) => {
    const root = $(rootDom);
    const current = $('.js-c-user-type-current', rootDom);
    const list = $('.js-c-user-type-list', rootDom);
    let focused = false;

    root.on('focus', SELECTOR.FOCUSABLE, () => {
        root.addClass(SELECTOR.ACTIVE);
        focused = true;
    });

    root.on('blur', SELECTOR.FOCUSABLE, () => {
        root.removeClass(SELECTOR.ACTIVE);
        focused = false;
    });

    current.on('click', () => {
        if (!focused) {
            root.toggleClass(SELECTOR.ACTIVE);
        }
        focused = false;
    });
});
